import { fromJS } from 'immutable'
import {
  PROJECT_INFORMATION_GET_SNAPSHOT_REQUEST,
  PROJECT_INFORMATION_GET_SNAPSHOT_SUCCESS,
  PROJECT_INFORMATION_GET_SNAPSHOT_FAILURE,
  PROJECT_INFORMATION_GET_SNAPSHOT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case PROJECT_INFORMATION_GET_SNAPSHOT_REQUEST:
      return state
        .set('isFetching', true)
    case PROJECT_INFORMATION_GET_SNAPSHOT_SUCCESS:
      return state
        .set('projectSnapshot', fromJS(action.payload.projectSnapshot))
        .set('isFetching', false)
        .set('status', 200)
        .set('message', 'Successfully.')
    case PROJECT_INFORMATION_GET_SNAPSHOT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('projectSnapshot', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case PROJECT_INFORMATION_GET_SNAPSHOT_RESET:
      return state
        .delete('projectSnapshot')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project-information/project-information-get-snapshot-reducer.js